<div class="group">
    <div class="count" [class]="get_class_by_name()">{{ group.count }}</div>
    <div class="name">{{ group.name }}</div>
    <div class="description">{{ group.description }}</div>
</div>